import { Select, Button, Empty } from 'antd'
import { useEffect, useState } from 'react'
import css from './Order.module.css'
import { useOrders } from './Order.Store'
import axios from 'axios'
import { Link } from 'react-router-dom'
import { 
    ShoppingCartOutlined, 
    EnvironmentOutlined, 
    PhoneOutlined,
    TagOutlined,
    CarOutlined,
    DollarOutlined,
    UserOutlined,
    CalendarOutlined,
    FileTextOutlined
} from '@ant-design/icons'

const Orders = () => {
    let { orders, getOrders, updateOrder } = useOrders()
    let [orderstatuses, setOrderstatuses] = useState([])

    useEffect(() => {
        getOrders()
        axios.get(`/order_statuses`).then(data => {
            setOrderstatuses(data.data)
        })
    }, [])

    const handleStatusChange = (orderId, newStatus) => {
        updateOrder({ id: orderId, order_status: newStatus })
    }

    const getInitials = (name) => {
        if (!name) return '?'
        return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2)
    }

    const getStatusCounts = () => {
        const counts = { total: orders.length, pending: 0, confirmed: 0, completed: 0 }
        orders.forEach(order => {
            if (order.order_status === 1) counts.pending++
            else if (order.order_status === 2) counts.confirmed++
            else if (order.order_status === 3) counts.completed++
        })
        return counts
    }

    const stats = getStatusCounts()

    return (
        <div className={css.container}>
            <div className={css.header}>
                <h1 className={css.title}>Buyurtmalar</h1>
            </div>

            <div className={css.statsBar}>
                <div className={css.statItem}>
                    <div className={css.statIcon.total}>
                        <ShoppingCartOutlined />
                    </div>
                    <div className={css.statInfo}>
                        <span className={css.statValue}>{stats.total}</span>
                        <span className={css.statLabel}>Jami</span>
                    </div>
                </div>
                <div className={css.statItem}>
                    <div className={css.statIcon.pending}>
                        <FileTextOutlined />
                    </div>
                    <div className={css.statInfo}>
                        <span className={css.statValue}>{stats.pending}</span>
                        <span className={css.statLabel}>Kutilmoqda</span>
                    </div>
                </div>
                <div className={css.statItem}>
                    <div className={css.statIcon.confirmed}>
                        <TagOutlined />
                    </div>
                    <div className={css.statInfo}>
                        <span className={css.statValue}>{stats.confirmed}</span>
                        <span className={css.statLabel}>Tasdiqlangan</span>
                    </div>
                </div>
                <div className={css.statItem}>
                    <div className={css.statIcon.completed}>
                        <DollarOutlined />
                    </div>
                    <div className={css.statInfo}>
                        <span className={css.statValue}>{stats.completed}</span>
                        <span className={css.statLabel}>Bajarilgan</span>
                    </div>
                </div>
            </div>

            {orders.length === 0 ? (
                <div className={css.emptyState}>
                    <div className={css.emptyIcon}>
                        <ShoppingCartOutlined />
                    </div>
                    <div className={css.emptyText}>Buyurtmalar mavjud emas</div>
                </div>
            ) : (
                <div className={css.ordersGrid}>
                    {orders.map((order) => (
                        <div className={css.orderCard} key={order.id}>
                            <div className={css.cardHeader}>
                                <div>
                                    <h3 className={css.orderId}>#{order.id}</h3>
                                    <div className={css.orderDate}>
                                        <CalendarOutlined style={{ marginRight: 4 }} />
                                        {order.created_at}
                                    </div>
                                </div>
                                <div className={css.customerInfo}>
                                    <div className={css.customerAvatar}>
                                        {getInitials(order.username)}
                                    </div>
                                    <div>
                                        <div className={css.customerName}>{order.username}</div>
                                        <div className={css.customerPhone}>
                                            <PhoneOutlined style={{ marginRight: 4 }} />
                                            {order.phone}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={css.cardBody}>
                                {order.comment && (
                                    <div className={css.comment}>
                                        <FileTextOutlined style={{ marginRight: 6 }} />
                                        {order.comment}
                                    </div>
                                )}

                                <div className={css.addressSection}>
                                    <div className={css.addressTitle}>
                                        <EnvironmentOutlined />
                                        Yetkazish Manzili
                                    </div>
                                    <div className={css.addressGrid}>
                                        <div className={css.addressItem}>
                                            <span className={css.addressLabel}>Viloyat</span>
                                            <span className={css.addressValue}>{order.region}</span>
                                        </div>
                                        <div className={css.addressItem}>
                                            <span className={css.addressLabel}>Tuman</span>
                                            <span className={css.addressValue}>{order.district}</span>
                                        </div>
                                        <div className={css.addressItem}>
                                            <span className={css.addressLabel}>Manzil</span>
                                            <span className={css.addressValue}>{order.address}</span>
                                        </div>
                                        <div className={css.addressItem}>
                                            <span className={css.addressLabel}>Pochta indeksi</span>
                                            <span className={css.addressValue}>{order.post_index}</span>
                                        </div>
                                    </div>
                                </div>

                                <div className={css.priceSection}>
                                    {order.discount > 0 && (
                                        <div className={css.priceRow}>
                                            <span className={css.priceLabel}>
                                                <TagOutlined style={{ marginRight: 4 }} />
                                                Chegirma
                                            </span>
                                            <span className={css.discountBadge}>
                                                -{order.discount} {order.valyuta_type}
                                                {order.discount_id && ` (${order.discount_id})`}
                                            </span>
                                        </div>
                                    )}
                                    <div className={css.priceRow}>
                                        <span className={css.priceLabel}>
                                            <CarOutlined style={{ marginRight: 4 }} />
                                            Yetkazib berish
                                        </span>
                                        <span className={css.priceValue}>
                                            {order.deliversumm} {order.valyuta_type}
                                        </span>
                                    </div>
                                    <div className={css.totalRow}>
                                        <span className={css.totalLabel}>Jami summa</span>
                                        <span className={css.totalValue}>
                                            {Number(order.total_summ).toLocaleString()} {order.valyuta_type}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div className={css.cardFooter}>
                                <div className={css.statusSelect}>
                                    <Select 
                                        style={{ width: '100%' }} 
                                        value={order.order_status}
                                        onChange={(value) => handleStatusChange(order.id, value)}
                                        options={orderstatuses.map((status) => ({
                                            value: status.id,
                                            label: status.nomi,
                                        }))} 
                                    />
                                </div>
                                <Link to={`/order/${order.id}`}>
                                    <Button className={css.batafsilBtn} type="primary">
                                        Batafsil
                                    </Button>
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}

export default Orders
